"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DeleteIcon;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); } // Generated by build-icons
// Do not edit by hand!
// @hash 79f9af2a2394f60bb36d3370dbd028e7cd1fbd63
const svgElement = /*#__PURE__*/_react.default.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/_react.default.createElement("path", {
  d: "M20.5 6h-17a.5.5 0 0 1-.5-.5v-1C3 3.122 4.121 2 5.5 2h2.691l.309-.618A2.486 2.486 0 0 1 10.736 0h2.527c.953 0 1.81.529 2.236 1.382l.31.618H18.5C19.879 2 21 3.122 21 4.5v1a.5.5 0 0 1-.5.5zM4 5h16v-.5c0-.827-.673-1.5-1.5-1.5h-3a.5.5 0 0 1-.447-.276l-.447-.895A1.493 1.493 0 0 0 13.264 1h-2.527a1.49 1.49 0 0 0-1.342.829l-.448.895A.5.5 0 0 1 8.5 3h-3C4.673 3 4 3.673 4 4.5V5z"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M16.5 24h-9C5.57 24 4 22.43 4 20.5v-15a.5.5 0 0 1 .5-.5h15a.5.5 0 0 1 .5.5v15c0 1.93-1.57 3.5-3.5 3.5zM5 6v14.5C5 21.878 6.121 23 7.5 23h9c1.379 0 2.5-1.122 2.5-2.5V6H5z"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M7.5 21a.5.5 0 0 1-.5-.5v-12a.5.5 0 0 1 1 0v12a.5.5 0 0 1-.5.5zM10.5 21a.5.5 0 0 1-.5-.5v-12a.5.5 0 0 1 1 0v12a.5.5 0 0 1-.5.5zM13.5 21a.5.5 0 0 1-.5-.5v-12a.5.5 0 0 1 1 0v12a.5.5 0 0 1-.5.5zM16.5 21a.5.5 0 0 1-.5-.5v-12a.5.5 0 0 1 1 0v12a.5.5 0 0 1-.5.5z"
}));
function DeleteIcon(props) {
  return /*#__PURE__*/_react.default.createElement("span", _extends({
    className: "icon icon-delete"
  }, props), svgElement);
}